import { computed, Ref, unref } from 'vue';
import { skipToken, useQuery } from '@tanstack/vue-query';
import { fetchAppVersionPage } from './report.endpoints';
import { TAppVersionPagePayload } from '../models/types';

export function useFetchAppVersionPage(payloadRef: Ref<TAppVersionPagePayload | null>) {
  const query = useQuery({
    queryKey: computed(() => {
      const payload = unref(payloadRef);
      return [
        'appVersionPage',
        payload?.integrationId,
        payload?.branchName,
        payload?.versionId,
        payload?.folderName,
        payload?.page,
        payload?.limit,
        payload?.filters,
      ];
    }),
    queryFn: computed(() => {
      const payload = unref(payloadRef);
      if (!payload) {
        return skipToken;
      }

      return () => fetchAppVersionPage(payload);
    }),
  });

  return query;
}
